/* eslint-disable no-console */
import Cookies from 'js-cookie'
import { getTokenFromRequestCookie } from '../helpers'
import { auth } from '~/services/firebase'

function getOrCreateGuestSessionId() {
  const key = 'ps_guest_session'
  let id = localStorage.getItem(key)
  if (!id) {
    id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    localStorage.setItem(key, id)
  }
  return id
}

export default function ({ $axios, redirect, app }) {
  $axios.onRequest((req) => {
    const token =
      app.$cookies.get('access_token') || getTokenFromRequestCookie(req)

    if (token) {
      req.headers.authorization = `Bearer ${token}`
    }

    if (process.client) {
      req.headers['X-Guest-Session'] = getOrCreateGuestSessionId()
    }

    // The page making the call, so a failed API route's Sentry event
    // (api/report-error.js) says where it came from. The route name
    // (`quote-setup-policyCode-payment`), not the path, so no quote or policy
    // codes go along. Same-origin only: this app's $axios never calls another
    // host, where a custom header would need CORS.
    const page = app.router && app.router.currentRoute.name
    if (page) req.headers['X-Page'] = page
  })
  $axios.onResponse((res) => {
    // console.log('onResponse ', res)
  })

  $axios.onError(async (error) => {
    const code = parseInt(error.response && error.response.status)
    const originalRequest = error.config

    if (code === 401 && !originalRequest.__isRetryRequest) {
      originalRequest.__isRetryRequest = true
      try {
        // Check if user is still logged in
        if (!auth.currentUser) {
          console.log('No current user, redirecting to login')
          redirect(`/login?nextUrl=${app.context.route.path}`)
          return Promise.reject(error)
        }
        // Refresh the token
        const token = await auth.currentUser.getIdToken(true)
        originalRequest.headers.authorization = `Bearer ${token}`
        Cookies.set('access_token', token, { sameSite: 'lax' })
        // Retry the original request
        return $axios(originalRequest)
      } catch (e) {
        console.log('Token refresh failed, redirecting to login', e)
        redirect(`/login?nextUrl=${app.context.route.path}`)
        return Promise.reject(e)
      }
    }
    return Promise.reject(error)
  })
}
